import {
  MerchantDashboardWidgetColumnsSchema,
  MerchantDashboardWidgetSizeSchema,
} from "@redotech/redo-views-common/merchant-dashboards";
import { merchantDashboardWidgetIdFormat } from "@redotech/redo-warehouse-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  MerchantDashboardWidgetSchema,
  MerchantDashboardWidgetTitleSchema,
} from "./merchant-dashboard-fields";

export const updateMerchantDashboardWidget = {
  name: "updateMerchantDashboardWidget" as const,
  input: z.object({
    widgetId: merchantDashboardWidgetIdFormat.schema,
    sourceViewId: zExt.objectId().optional(),
    title: MerchantDashboardWidgetTitleSchema.optional(),
    columns: MerchantDashboardWidgetColumnsSchema.optional(),
    size: MerchantDashboardWidgetSizeSchema.optional(),
  }),
  output: z.object({ widget: MerchantDashboardWidgetSchema }),
};
